var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4844 9.70872C18.4844 9.0578 18.426 8.43191 18.3177 7.83105H9.68335V11.3819H14.6173C14.4047 12.5294 13.7588 13.5016 12.7879 14.1525V16.4558H15.7507C17.4843 14.8577 18.4844 12.5044 18.4844 9.70872Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68334 18.6797C12.1586 18.6797 14.2339 17.8577 15.7507 16.4557L12.7879 14.1524C11.9669 14.7032 10.9168 15.0287 9.68334 15.0287C7.29556 15.0287 5.27449 13.4139 4.55358 11.2441H1.49072V13.6225C2.99923 16.6226 6.09959 18.6797 9.68334 18.6797Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55359 11.2441C4.37024 10.6933 4.26606 10.105 4.26606 9.49997C4.26606 8.89494 4.37024 8.3066 4.55359 7.75582V5.37744H1.49074C0.848997 6.65664 0.515059 8.06844 0.515626 9.49997C0.515626 10.9812 0.869834 12.3832 1.49074 13.6225L4.55359 11.2441Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68334 3.97134C11.0293 3.97134 12.2378 4.43449 13.1879 5.34412L15.8174 2.71121C14.2297 1.22994 12.1545 0.320312 9.68334 0.320312C6.09959 0.320312 2.99923 2.3774 1.49072 5.3775L4.55358 7.75588C5.2745 5.58613 7.29556 3.97134 9.68334 3.97134Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.6b968f99b04821746327b4ac7f21a33a.svg";
export { ForwardRef as ReactComponent };